import "./SocialMediaJobShare.scss";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";

interface SocialMediaJobShare {
  shareUrl?: any;
  title?: any;
  description?: any;
  hashtags?: any;
}
const SocialMediaJobShare = ({
  shareUrl,
  title,
  description,
  hashtags,
}: SocialMediaJobShare) => {
  // watsapp share
  const convertHtmlToWhatsappText = (html: any) => {
    return (
      html
        // Convert headings (H1-H6) to bold
        .replace(/<h[1-6]>(.*?)<\/h[1-6]>/g, "\n\n*$1*")
        // Convert bold text
        .replace(/<strong>(.*?)<\/strong>|<b>(.*?)<\/b>/g, "*$1$2*")
        // Convert italic text
        .replace(/<em>(.*?)<\/em>|<i>(.*?)<\/i>/g, "_$1$2_")
        // Convert underlined text (WhatsApp doesn't support underline, so use bold)
        .replace(/<u>(.*?)<\/u>/g, "*$1*")
        // Convert paragraphs
        .replace(/<p>(.*?)<\/p>/g, "\n$1")
        // Convert list items
        .replace(/<li>(.*?)<\/li>/g, "\n• $1")
        // Remove unordered & ordered list tags
        .replace(/<\/?ul>|<\/?ol>/g, "")
        // Convert horizontal rule to a separator
        .replace(/<hr>/g, "\n------------------\n")
        // Convert line breaks
        .replace(/<br\s*\/?>/g, "\n")
        // Convert blockquotes
        .replace(/<blockquote>(.*?)<\/blockquote>/g, "\n'$1")
        // Convert table headers (bold)
        .replace(/<th>(.*?)<\/th>/g, "*$1*")
        // Convert table rows & columns
        .replace(/<tr>/g, "\n")
        .replace(/<td>(.*?)<\/td>/g, "$1 | ")
        // Remove remaining table tags
        .replace(/<\/?(table|tbody|tr)>/g, "")
        // Convert email links
        .replace(/<a href="mailto:(.*?)"[^>]*>(.*?)<\/a>/g, "$2 ($1)")
        // Convert web links
        .replace(/<a href="(.*?)"[^>]*>(.*?)<\/a>/g, "$2 [$1]")
        // Remove all other HTML tags
        .replace(/<\/?[^>]+(>|$)/g, "")
    );
  };
  const formattedMessage = `${title}\n${convertHtmlToWhatsappText(description)}\n${hashtags}\n`;

  return (
    <div className="socialContainer">
      <div className="socialButton">
        <FacebookShareButton
          url={shareUrl}
          hashtag={`${hashtags}`}
          className="buttonIcon"
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </div>
      <div className="socialButton">
        <TwitterShareButton
          url={shareUrl}
          title={formattedMessage}
          className="buttonIcon"
        >
          <XIcon size={32} round />
        </TwitterShareButton>
      </div>

      <div className="socialButton">
        <WhatsappShareButton
          url={shareUrl}
          title={formattedMessage}
          separator=" "
          className="buttonIcon"
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </div>

      <div className="socialButton">
        <LinkedinShareButton url={shareUrl} className="buttonIcon">
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </div>
    </div>
  );
};
export default SocialMediaJobShare;
